module.exports = __webpack_public_path__ + "static/media/gazzetta.1ed285a7.png";